import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ApiTokboxService } from '../../../../../../api/apiTokbox';
import { StartRecordResponse, StopRecordResponse, Item } from '../../../../../../api/apiTokbox/opentok.model';
import { Room } from '../../../../../../models';
import { EnvironmentService } from '../../../../../../services/enviroment/environment.service';
import { StateHandlerService } from '../../../../../../services/state-handler/state-handler.service';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [TranslateDirective],
  selector: 'sas-rec-video',
  templateUrl: './rec-video.component.html',
  styleUrls: ['./rec-video.component.scss'],
})
export class RecVideoComponent implements OnInit, OnDestroy {
  @Input() screenSharedSupported?: boolean;
  @Input() switchCameraSupported?: boolean;
  @Input() showTooltip?: boolean;
  @Input() showVideoList?: boolean;
  @Output() closePopUp: EventEmitter<any> = new EventEmitter();
  @Output() showBtnStopRecord: EventEmitter<any> = new EventEmitter();
  public archives?: Item[];
  recordVideoSD?: boolean;
  recordVideoHD?: boolean;

  constructor(
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly environmentService: EnvironmentService,
    private readonly stateHandlerSrv: StateHandlerService
  ) {}

  // TODO: cambiar los nombres de los iconos y los textos por es.json y variables
  ngOnInit(): void {
    this.getRoomData();
    this.recordVideoHD =
      this.environmentService?.data?.features?.record_video_HD;
    this.recordVideoSD =
      this.environmentService?.data?.features?.record_video_SD;
  }

  getRoomData() {
    this.stateHandlerSrv.get('roomData').subscribe((roomDataStorage: Room) => {
      this.apiTokBoxSvc.roomData = roomDataStorage;
      this.listArchives();
    });
  }

  // method that call service to get recording archives from the server and call to checkStatusRecording.
  async record(resolution: string) {
    this.checkStatusRecording(
      this.getActualArchive(this.archives || []),
      resolution
    );
  }

  // method that get the recording archives
  async listArchives() {
    await this.apiTokBoxSvc
      .listArchives()
      .toPromise()
      .then(
        (archives: Item[]) => {
          if (archives.length) {
            this.archives = this.formatDate(archives);
          } else {
            this.archives = archives;
            this.showTooltip = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
  }

  // method that gets the last archive from listArchives.
  getActualArchive(archives: Item[]) {
    if (archives && archives.length) {
      return archives[0];
    }else{
      return undefined;
    }
  }

  // method that format the timeStamp Date
  formatDate(archives: Item[]) {
    archives.forEach((archive) => {
      archive.createdAt = new Date(archive.createdAt);
    });

    return archives;
  }

  // method that starts the recording
  startRecord(resolution: any) {
    this.apiTokBoxSvc.startRecord(resolution).subscribe({
      next: (startRecordResponse: StartRecordResponse) => {
        this.showBtnStopRecord.emit({
          archiveId: startRecordResponse.id,
          showButton: true,
        });
        this.listArchives();
        this.showTooltip = false;
        this.closePopUp.emit();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  // method that stop the recording
  stopRecord(archiveId: any) {
    this.apiTokBoxSvc.StopRecord(archiveId).subscribe({
      next: (stopRecordResponse: StopRecordResponse) => {
        this.showBtnStopRecord.emit({ showButton: false });
        this.listArchives();
        this.showTooltip = false;
        this.closePopUp.emit();
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  // method that delete archives from id.
  deleteArchive(archiveId: string) {
    this.apiTokBoxSvc
      .deleteArchive(archiveId)
      .subscribe((deleteResponse: any) => {
        this.listArchives();
        this.closePopUp.emit();
      });
  }

  // method that check if the recording is activated and stop or start it.
  checkStatusRecording(archive: any, resolution: string) {
    if (
      !archive ||
      (archive.status !== 'started' && archive.status !== 'paused')
    ) {
      this.startRecord(resolution);
    } else {
      this.stopRecord(archive.id);
      setTimeout(() => this.listArchives(), 7000);
    }
  }

  cancel(ev: Event) {
    this.showVideoList = false;
    this.showTooltip = false;
    this.closePopUp.emit();
  }

  goToVideo(archive: any) {
    window.open(archive);
    this.closePopUp.emit();
  }

  ngOnDestroy() {
    this.closePopUp.emit();
  }
}
